import { useLanguage } from "@/contexts/LanguageContext";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { UserPlus } from "lucide-react";
import { CampaignCreator } from "@/components/campaign/CampaignCreator";

interface AffiliateCampaignCreateProps {
  clientInfo: {
    clientName: string;
    clientEmail: string;
    clientCompany: string;
    clientPhone: string;
  };
  onClientInfoChange: (info: AffiliateCampaignCreateProps['clientInfo']) => void;
}

export const AffiliateCampaignCreate = ({ clientInfo, onClientInfoChange }: AffiliateCampaignCreateProps) => {
  const { language } = useLanguage();
  const isRTL = language === 'ar';

  return (
    <div className="space-y-6">
      {/* Client Information Card */}
      <Card className="border-primary/20 bg-primary/5">
        <CardHeader>
          <CardTitle className="flex items-center gap-2 text-lg">
            <UserPlus className="h-5 w-5 text-primary" />
            {isRTL ? "معلومات العميل" : "Client Information"}
          </CardTitle>
          <CardDescription>
            {isRTL ? "أدخل بيانات العميل لحجز هذه الحملة نيابة عنه" : "Enter the client details for this campaign booking on their behalf"}
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label>{isRTL ? "اسم العميل" : "Client Name"} *</Label>
              <Input
                value={clientInfo.clientName}
                onChange={e => onClientInfoChange({ ...clientInfo, clientName: e.target.value })}
                placeholder={isRTL ? "أدخل اسم العميل" : "Enter client name"}
              />
            </div>
            <div className="space-y-2">
              <Label>{isRTL ? "بريد العميل" : "Client Email"} *</Label>
              <Input
                type="email"
                value={clientInfo.clientEmail}
                onChange={e => onClientInfoChange({ ...clientInfo, clientEmail: e.target.value })}
                placeholder={isRTL ? "أدخل بريد العميل" : "Enter client email"}
              />
            </div>
            <div className="space-y-2">
              <Label>{isRTL ? "شركة العميل" : "Client Company"}</Label>
              <Input
                value={clientInfo.clientCompany}
                onChange={e => onClientInfoChange({ ...clientInfo, clientCompany: e.target.value })}
                placeholder={isRTL ? "أدخل اسم الشركة" : "Enter company name"}
              />
            </div>
            <div className="space-y-2">
              <Label>{isRTL ? "هاتف العميل" : "Client Phone"}</Label>
              <Input
                value={clientInfo.clientPhone}
                onChange={e => onClientInfoChange({ ...clientInfo, clientPhone: e.target.value })}
                placeholder={isRTL ? "أدخل رقم الهاتف" : "Enter phone number"}
              />
            </div>
          </div>
        </CardContent>
      </Card>

      {/* Campaign Creator */}
      <CampaignCreator />
    </div>
  );
};
